// 马来语（马来西亚）
export default {
  company: {
    deviceList: 'Senarai Peranti',
    name: 'Karamel Filem',
    desc: 'Nikmati masa yang indah!',
    companyName: 'Nama Kedai',
    companyInfo: 'Maklumat Pedagang',
    linkMan: 'Orang Hubungan',
    contactInfo: 'Maklumat Hubungan',
    cooperationWay: 'Cara Kerjasama',
    jointOperation: 'Usahasama',
    selfOperated: 'Kendiri',
    agent: 'Ejen',
    businessStatus: 'Status Perniagaan',
    operating: 'Beroperasi',
    stopped: 'Ditutup',
    hasBackend: 'Backend Diaktifkan',
    backendAccount: 'Akaun Backend',
    backendPassword: 'Kata Laluan Backend',
    deviceCount: 'Bilangan Mesin',
    orderData: 'Data Pesanan',
    companyRatio: 'Nisbah Pedagang (%)',
    operatorRatio: 'Nisbah Pengendali (%)',
    companyDesc: 'Penerangan Pedagang',
    companyAddress: 'Alamat Pedagang',
    openAggregatedPay: 'Bayaran Agregat Diaktifkan',
    thirdPayWay: 'Kaedah Bayaran Pihak Ketiga',
    merchantId: 'ID Pedagang',
    merchantType: 'Jenis Pedagang',
    merchantAppid: 'Appid Pedagang',
    wechatRedirectUrl: 'URL Ubah Hala Bayaran WeChat',
    payNotifyUrl: 'URL Panggil Balik Bayaran',
    refundNotifyUrl: 'URL Panggil Balik Bayaran Balik',
    sqbMerchantCode: 'Kod Pedagang (Shouqianba)',
    sqbDeveloperKey: 'Kunci Pembangun Shouqianba',
    storeActiveCode: 'Kod Pengaktifan Kedai',
    frontendCallbackUrl: 'URL Panggil Balik Frontend',
    merchantSecret: 'Secret Pedagang',
    unit: 'unit',
    merchantLevel: 'Tahap Pedagang',
    level2Merchant: 'Pedagang Tahap 2',
    level3Merchant: 'Pedagang Tahap 3',
    aggregatedPayMerchant: 'Pedagang Pembayaran Agregat',
    backendOpen: 'Backend Dibuka',
    forwardIncomingPrefix: 'Huilaimi Masuk_',
    qrCodeGenerateFailed: 'Gagal menjana kod QR, sila cuba lagi',
    invalidWebUrl: 'URL web yang diperoleh tidak sah, sila hubungi pentadbir',
    noValidWebUrl: 'Tiada URL web yang sah diperoleh',
    fetchDataFailed: 'Gagal mendapatkan data, sila cuba lagi',
    browserNotSupportDownload: 'Pelayar anda tidak menyokong muat turun automatik, sila klik kanan untuk menyimpan imej',
    downloadImageFailed: 'Gagal memuat turun imej, sila cuba lagi',
    httpError: 'Ralat HTTP, kod status: {status}',
    copyCompanyName: 'Salin nama kedai',
    copySuccess: 'Berjaya disalin',
    copyFail: 'Gagal menyalin'
  },
  income: {
    totalIncome: 'Jumlah Keseluruhan Pesanan',
    platformIncome: 'Bahagian Platform',
    companyIncome: 'Pendapatan Sistem Pedagang',
    subMerchantIncome: 'Bahagian Pedagang Tahap Tiga',
    parentIncome: 'Kekalan Pedagang Tahap Dua',
    orderCount: 'Bilangan Pesanan',
    subMerchantIncomeDetail: 'Butiran Pendapatan Pedagang Tahap Tiga',
    subRatioText: 'Kekalan tahap tiga',
    subJustRatioText: 'Komisen tahap dua',
    splitRatio: 'Nisbah Pembahagian',
    deviceCount: 'Bilangan Peranti',
    deviceCode: 'Kod Peranti',
    deviceName: 'Nama Peranti'
  },
  login: {
    username: 'Nama pengguna',
    password: 'Kata laluan',
    login: 'Log masuk',
    inputUsername: 'Sila masukkan nama pengguna',
    inputPassword: 'Sila masukkan kata laluan'
  },
  employee: {
    inputAccount: 'Sila masukkan akaun',
    inputName: 'Sila masukkan nama',
    inputMobile: 'Sila masukkan nombor telefon',
    selectRole: 'Sila pilih peranan',
    allRoles: 'Semua peranan',
    allStatus: 'Semua status',
    collapse: 'Lipat',
    expand: 'Kembang',
    employeeCount: 'Bilangan pekerja: ',
    addEmployee: '+ Tambah Pekerja',
    account: 'Akaun',
    name: 'Nama',
    gender: 'Jantina',
    role: 'Peranan',
    company: 'Syarikat berkaitan',
    creator: 'Ditambah oleh',
    createTime: 'Masa ditambah',
    devicePermission: 'Kebenaran peranti',
    deviceCountUnit: '{count} peranti',
    viewAllDevices: 'Lihat semua peranti',
    disableAccount: 'Nyahaktif',
    resetPassword: 'Set semula kata laluan',
    assignDevices: 'Peruntukkan peranti',
    tip: 'Notis',
    deleteConfirm: 'Selepas akaun dipadam, akaun tidak lagi dapat log masuk ke sistem. Sahkan pemadaman?',
    employeeName: 'Nama pekerja: ',
    usernameLabel: 'Nama pengguna: ',
    currentPermission: 'Kebenaran semasa: ',
    assignedDevices: '{count} peranti diperuntukkan',
    selectDevice: 'Pilih peranti: ',
    selectDevicePlaceholder: 'Sila pilih peranti',
    deviceHint: 'Tidak memilih sebarang peranti bermakna pekerja boleh melihat semua peranti syarikat',
    selectAtLeastOneDevice: 'Sila pilih sekurang-kurangnya 1 peranti',
    assignSuccess: 'Peranti berjaya diperuntukkan',
    assignFailed: 'Gagal memperuntukkan',
    loadDeviceInfoFailed: 'Gagal memuatkan maklumat peranti',
    loadDeviceListFailed: 'Gagal memuatkan senarai peranti',
    disableConfirmTitle: 'Adakah anda pasti mahu menyahaktifkan akaun pekerja ini?',
    disableConfirmContent: 'Selepas dinyahaktif, pekerja tidak dapat log masuk',
    disableSuccess: 'Berjaya dinyahaktif',
    enableConfirmTitle: 'Adakah anda pasti mahu mengaktifkan akaun pekerja ini?',
    enableConfirmContent: 'Selepas diaktif, pekerja boleh log masuk',
    enableSuccess: 'Berjaya diaktif',
    resetPwdConfirmTitle: 'Adakah anda pasti mahu set semula kata laluan pekerja ini?',
    resetPwdConfirmContent: 'Selepas set semula, kata laluan akan kembali kepada kata laluan lalai (JTphoto0515)',
    resetPwdSuccess: 'Kata laluan berjaya diset semula',
    addSuccess: 'Pekerja berjaya ditambah',
    updateSuccess: 'Pekerja berjaya diubah',
    addTitle: 'Tambah Pekerja',
    editTitle: 'Ubah Pekerja',
    accountLabel: 'Akaun:',
    nameLabel: 'Nama:',
    passwordLabel: 'Kata laluan:',
    defaultPwdTip: 'Biarkan kosong untuk menggunakan kata laluan lalai JTphoto0515',
    defaultPwdPlaceholder: 'Biarkan kosong untuk kata laluan lalai',
    emailLabel: 'E-mel:',
    emailInvalid: 'Sila masukkan e-mel yang sah',
    maxLength50: 'Panjang tidak boleh melebihi 50 aksara',
    mobileLabel: 'Telefon:',
    mobileInvalid: 'Sila masukkan nombor telefon yang sah',
    roleSetting: 'Peranan:',
    statusSetting: 'Status:',
    selectStatus: 'Sila pilih status',
    genderSetting: 'Jantina:',
    selectGender: 'Sila pilih jantina',
    deptSetting: 'Jabatan:',
    remarkLabel: 'Catatan:',
    remarkPlaceholder: 'Sila masukkan catatan',
    submit: 'Hantar',
    save: 'Simpan',
    usernameRequired: 'Nama pengguna tidak boleh kosong',
    usernameMax20: 'Nama pengguna tidak boleh melebihi 20 aksara',
    usernameMin4: 'Nama pengguna tidak boleh kurang daripada 4 aksara',
    usernameExists: 'Maaf, nama pengguna ini sudah wujud',
    mobileRequired: 'Nombor telefon tidak boleh kosong!',
    nameRequired: 'Nama tidak boleh kosong!',
    roleRequired: 'Peranan tidak boleh kosong!'
  },
  homepage: {
    totalIP: 'Jumlah IP',
    todayfc: 'Pendapatan hari ini',
    weekQOQ: 'Banding minggu',
    dayQOQ: 'Banding hari',
    todayCompanyIncome: 'Pendapatan kedai hari ini',
    todayPlatformIncome: 'Pendapatan platform hari ini',
    todayFlow: 'Aliran pelanggan hari ini',
    todayOrder: 'Pesanan hari ini',
    todayRefundOrder: 'Pesanan bayaran balik hari ini',
    machineOnlineCount: 'Mesin dalam talian',
    machineOfflineCount: 'Mesin luar talian',
    totalPlatformIncome: 'Jumlah pendapatan platform',
    totalOperatorIncome: 'Jumlah bahagian pengendali',
    totalCompanyIncome: 'Jumlah pendapatan kedai',
    totalFlow: 'Jumlah aliran pelanggan',
    totalOrder: 'Jumlah pesanan',
    totalRefundOrder: 'Jumlah pesanan bayaran balik',
    usage: 'Penggunaan',
    incomeAmount: 'Jumlah pendapatan',
    flow: 'Aliran pelanggan',
    orderCount: 'Bilangan pesanan',
    todayIncome: 'Pendapatan hari ini',
    lastLoginTime: 'Masa log masuk terakhir',
    canWithdrawalIncome: 'Pendapatan boleh keluarkan',
    goodMorning: 'Selamat pagi',
    goodForenoon: 'Selamat tengah pagi',
    goodNoon: 'Selamat tengah hari',
    goodAfternoon: 'Selamat petang',
    goodEvening: 'Selamat malam',
    welcome1: 'Minum kopi dan berehat sekejap ☕',
    welcome2: 'Nak main LOL dengan kawan?',
    welcome3: 'Nak main Honor of Kings dengan kawan?',
    welcome4: 'Beberapa hari tidak jumpa nampak lebih cantik 😍',
    welcome5: 'Hari ini tulis berapa Bug 🐞?',
    welcome6: 'Hari ini sembang dalam kumpulan?',
    welcome7: 'Hari ini makan apa yang sedap?',
    welcome8: 'Hari ini kamu tersenyum belum 😊?',
    welcome9: 'Hari ini bantu orang lain selesaikan masalah?',
    welcome10: 'Nak makan apa?',
    welcome11: 'Hujung minggu nak tengok wayang?',
    dateRange: '{start}~{end}',
    withdraw: 'Keluarkan wang',
    avatarAlt: 'Avatar',
    noDept: 'Tiada jabatan',
    noRole: 'Tiada peranan',
    firstVisit: 'Lawatan pertama',
    todayIp: 'IP hari ini',
    todayVisit: 'Lawatan hari ini',
    totalVisit: 'Jumlah lawatan',
    lowPaperTitle: 'Peringatan Kertas Gambar Tidak Mencukupi',
    lowPaperTip: 'Peranti berikut mempunyai baki kertas gambar kurang daripada {count} keping, sila tambah kertas dengan segera supaya tidak menjejaskan penggunaan biasa!',
    lowPaperDeviceName: 'Nama Peranti',
    lowPaperDeviceCode: 'Kod Peranti',
    lowPaperCount: 'Bilangan Kertas',
    lowPaperClose: 'Tutup'
  },
  device: {
    companyManage: 'Urus kedai',
    deviceManage: 'Urus peranti',
    totalDevices: 'Jumlah mesin',
    all: 'Semua',
    online: 'Dalam talian',
    offline: 'Luar talian',
    updating: 'Sedang kemas kini',
    versionUpdate: 'Kemas kini versi',
    export: 'Eksport',
    batchUpdate: 'Kemas kini berkumpulan',
    unbind: 'Nyahpaut',
    bind: 'Paut',
    companyName: 'Nama kedai',
    deviceCode: 'Kod peranti',
    appVersion: 'Versi aplikasi',
    sn: 'Nombor siri',
    uiName: 'Nama UI',
    uiGroupName: 'Kumpulan UI',
    photoTime: 'Masa foto',
    intervalTime: 'Selang masa foto',
    pagerNum: 'Bilangan kertas',
    goodsNum: 'Bilangan produk',
    filterNum: 'Bilangan penapis',
    address: 'Alamat Mesin',
    orderCount: 'Bilangan pesanan',
    operation: 'Operasi',
    command: 'Arahan berjaya dihantar',
    reset: 'Tetap semula',
    restartApp: 'Mulakan semula aplikasi',
    showMenu: 'Tunjuk menu',
    hideMenu: 'Sembunyi menu',
    reportLog: 'Laporkan log',
    isSupperCoins: 'Sokong syiling',
    unbinded: 'Telah nyahpaut',
    binded: 'Telah paut',
    bindStatus: 'Status pengikatan',
    lastestOnlineTime: 'Masa dalam talian terakhir',
    macAddress: 'Alamat MAC',
    resolution: 'Resolusi',
    deviceSN: 'SN peranti',
    deviceVersion: 'Versi peranti',
    deviceKey: 'Kunci peranti',
    deviceIMEI: 'IMEI peranti',
    activationCode: 'Kod pengaktifan',
    leyaoyaoCode: 'Kod Leyaoyao',
    electronicPhoto: 'Foto elektronik',
    scanDownload: 'Imbas untuk muat turun',
    sendFriend: 'Hantar kepada kawan',
    templateImage: 'Imej templat',
    working: 'Sedang bekerja',
    workStatus: 'Status kerja',
    thumbnail: 'Gambar Kecil',
    remoteCode: 'Kod Jauh',
    belongCategory: 'Kategori',
    allMerchants: 'Semua Peniaga',
    assign: 'Tetapkan',
    viewOrders: 'Lihat Pesanan',
    selectBindMerchant: 'Sila pilih peniaga untuk dipautkan',
    pendingVendorActive: 'Pengaktifan Shouqianba tertunda',
    vendorActivationCode: 'Kod pengaktifan Shouqianba',
    vendorActivationCodePlaceholder: 'Sila masukkan kod pengaktifan Shouqianba',
    vendorActivationCodeRequired: 'Sila masukkan kod pengaktifan Shouqianba',
    merchantName: 'Nama Peniaga',
    selectMerchantName: 'Sila pilih nama peniaga',
    assignDeviceToSub: 'Tetapkan Peranti kepada Sub-peniaga',
    deviceLabel: 'Peranti: ',
    targetMerchant: 'Peniaga Sasaran',
    selectSubMerchant: 'Sila pilih sub-peniaga',
    noSubMerchant: 'Tiada sub-peniaga tersedia, sila cipta peniaga tahap 3 terlebih dahulu',
    selectTargetMerchant: 'Sila pilih peniaga sasaran',
    assignSuccess: 'Peranti berjaya ditetapkan',
    assignFailed: 'Gagal menetapkan peranti',
    selectDeviceToUpdate: 'Sila pilih peranti untuk dikemas kini! Sekurang-kurangnya satu',
    setupSuccess: 'Tetapan peranti berjaya',
    updateUI: 'Kemas Kini UI',
    updateApp: 'Kemas Kini APP',
    updateConfig: 'Kemas Kini Konfigurasi',
    shellExec: 'Pelaksanaan Arahan Shell',
    shellCommand: 'Arahan Shell',
    shellCommandPlaceholder: 'Masukkan arahan Shell untuk dilaksanakan, contoh: ls -la /tmp',
    sendShellCommand: 'Hantar Arahan Shell',
    dangerousConfirmTip: 'Arahan berbahaya memerlukan pengesahan',
    notifiedUpdateUI: 'Peranti dimaklumkan untuk kemas kini UI',
    notifiedUpdateApp: 'Peranti dimaklumkan untuk kemas kini APP',
    notifiedUpdateConfig: 'Peranti dimaklumkan untuk kemas kini konfigurasi',
    inputShellCommand: 'Sila masukkan arahan Shell',
    dangerousWarningTitle: '⚠️ Amaran Operasi Berbahaya',
    dangerousWarningContent: 'Anda sedang melaksanakan arahan berbahaya yang boleh menyebabkan peranti tidak normal! Teruskan?',
    confirmExecute: 'Sahkan Pelaksanaan',
    commandSent: 'Arahan dihantar, sila tunggu peranti melaksanakannya',
    sendFailed: 'Gagal menghantar',
    networkError: 'Ralat rangkaian, sila cuba lagi kemudian',
    confirmUnbind: 'Selepas dinyahikat, peranti akan dipisahkan daripada pedagang. Adakah anda pasti mahu menyahikat peranti ini?',
    copyCompanyName: 'Salin nama kedai',
    copyDeviceCode: 'Salin kod peranti',
    copyActiveCode: 'Salin kod pengaktifan',
    copySuccess: 'Berjaya disalin',
    copyFail: 'Gagal menyalin'
  },
  setting: {
    navbarColor: 'Warna bar navigasi',
    themeColor: 'Warna tema',
    navbarPosition: 'Kedudukan bar navigasi',
    fixedTopRail: 'Tetapkan bar atas',
    fixedSidebar: 'Tetapkan bar sisi',
    multiTabMode: 'Mod berbilang tab',
    languageSwitching: 'Tukar bahasa',
    userCenter: 'Pusat pengguna',
    updatePassword: 'Kemas kini kata laluan',
    customSystem: 'Sesuaikan sistem',
    logout: 'Log keluar',
    updateCache: 'Kemas kini cache',
    refreshCacheSuccess: 'Cache berjaya dikemas kini',
    refreshCacheFailed: 'Gagal mengemas kini cache'
  },
  common: {
    confirm: 'Sahkan',
    cancel: 'Batal',
    saveSetting: 'Simpan tetapan',
    languageChanged: 'Tukar bahasa berjaya',
    timezoneChanged: 'Tukar zon waktu berjaya',
    search: 'Cari',
    pleaseInputContent: 'Sila masukkan kandungan',
    export: 'Eksport',
    default: 'Lalai',
    item: 'Item',
    view: 'Lihat',
    setup: 'Tetapan',
    status: 'Status',
    showTotal: 'Papar {start} ~ {end} rekod, jumlah {total} rekod',
    yes: 'Ya',
    no: 'Tidak',
    info: 'Maklumat',
    sequenceNumber: 'No.',
    creationTime: 'Masa cipta',
    operation: 'Operasi',
    defaultSort: 'Nombor susunan',
    type: 'Dibina dalam',
    edit: 'Edit',
    delete: 'Padam',
    deleteSuccess: 'Padam berjaya',
    editSuccess: 'Edit berjaya',
    updateSuccess: 'Kemas kini berjaya',
    connectionError: 'Sambungan pelayan tidak normal, sila cuba lagi kemudian!',
    reset: 'Tetap semula',
    allCategory: 'Semua kategori',
    query: 'Pertanyaan',
    add: 'Tambah',
    loadError: 'Ralat muat',
    isDefault: 'Lalai',
    setDefault: 'Tetapkan sebagai lalai',
    cancelDefault: 'Batal lalai',
    batchEdit: 'Edit berkumpulan',
    back: 'Kembali',
    uploadImg: 'Muat naik imej',
    uploadImgSuccess: 'Muat naik imej berjaya',
    uploadImgFailed: 'Muat naik gagal',
    uploadImgTips1: 'Hanya format JPG, JPEG, GIF, PNG dibenarkan',
    uploadImgTips2: 'Fail melebihi had 10M, tidak dibenarkan muat naik',
    addSuccess: 'Tambah berjaya',
    all: 'Semua',
    batchAdd: 'Tambah Kelompok',
    deleteError: 'Padam gagal',
    deleteNoData: 'Sila pilih data yang ingin dipadam',
    disable: 'Dinyahaktifkan',
    enable: 'Diaktifkan',
    exportError: 'Eksport gagal!',
    exportExecl: 'Eksport Excel',
    exportSuccess: 'Eksport berjaya',
    noData: 'Tiada Data',
    operateError: 'Operasi gagal, sila cuba lagi',
    prompt: 'Petua',
    searchError: 'Carian gagal',
    selectDataFirst: 'Sila pilih pelekat yang ingin dieksport terlebih dahulu!',
    uploadError: 'Muat naik gagal',
    selectAll: 'Pilih Semua',
    totalRecords: 'Jumlah {total} rekod',
    closeLeft: 'Tutup kiri',
    closeRight: 'Tutup kanan',
    closeOthers: 'Tutup yang lain'
  },
  template: {
    merchantManagement: 'Urus kedai',
    uiManagement: 'Urus UI',
    newConfig: 'Bingkai baru',
    editFrame: 'Sunting bingkai',
    editConfig: 'Edit konfigurasi',
    top: 'Atas',
    bottom: 'Bawah',
    builtIn: 'Dibina dalam',
    nonBuiltIn: 'Bukan dibina dalam',
    uiConfigName: 'Nama UI',
    background: 'Latar belakang',
    wechatOfficialAccount: 'Kod QR',
    title: 'Tajuk',
    banner: 'Banner',
    creationTime: 'Masa cipta',
    indicatorColor: 'Warna penunjuk',
    type: 'Jenis',
    appliedMachines: 'Bilangan mesin digunakan',
    freamName: 'Nama bingkai',
    editSuccess: 'Edit UI berjaya',
    tip: 'Petua',
    deletePrompt: 'Memadam konfigurasi UI ini akan menyebabkan pengguna tidak dapat menggunakannya. Anda pasti mahu memadam?',
    matchProduct: 'Padankan produk',
    selectProduct: 'Sila pilih produk',
    templateFilePng: 'Fail templat PNG',
    maxFileSize: 'Saiz fail maksimum 10M',
    addUploadImage: 'Tambah imej muat naik',
    previewImage: 'Imej pratonton',
    cuttingImage: 'Imej potongan',
    groupPhotoFrame: 'Bingkai foto bersama',
    groupPhotoYes: 'Foto bersama',
    groupPhotoNo: 'Bukan foto bersama',
    groupPhotoLensSetting: 'Tetapan butiran kanta foto bersama',
    groupPhotoConfigured: 'Foto bersama telah dikonfigurasi',
    groupPhotoNotSet: 'Foto bersama belum ditetapkan',
    buttonNormal: 'Butang biasa',
    buttonPressed: 'Butang ditekan',
    buttonNormalExample: 'Contoh butang normal',
    buttonPressedExample: 'Contoh butang ditekan',
    reuseTemplateFile: 'Guna semula fail templat',
    reuseNormalButton: 'Guna semula butang normal',
    reuseAllTemplateFiles: 'Guna semula semua fail templat',
    addSticker: 'Tambah Pelekat',
    editSticker: 'Sunting Pelekat',
    StickerIndexNum: 'Nombor Susunan',
    onlyImage: 'Hanya imej JPG, JPEG, GIF dan PNG boleh dimuat naik',
    selectCategory: 'Sila pilih kategori',
    selectStatus: 'Sila pilih status',
    selectType: 'Sila pilih jenis',
    stickerCategory: 'Kategori Pelekat',
    stickerCode: 'Kod Pelekat',
    stickerFileSize: 'Saiz Fail',
    stickerName: 'Nama Pelekat',
    stickerPreview: 'Imej Pelekat',
    stickerStatus: 'Status',
    stickerType: 'Jenis',
    staticSticker: 'Pelekat Statik',
    gifSticker: 'Animasi GIF',
    videoSticker: 'Pelekat Video',
    frameGroup: 'Kumpulan Bingkai'
  },
  sticker: {
    stickerPreview: 'Imej pelekat',
    stickerCode: 'Kod pelekat',
    stickerCategory: 'Kategori pelekat',
    stickerType: 'Jenis',
    stickerSize: 'Saiz',
    stickerFileSize: 'Saiz fail',
    StickerIndexNum: 'Nombor indeks',
    stickerStatus: 'Status',
    stickerName: 'Nama pelekat',
    stickerOperation: 'Operasi',
    addSticker: 'Tambah pelekat',
    stickerImage: 'Imej pelekat',
    stickerThumbnail: 'Gambar kecil',
    stickerWidth: 'Lebar (piksel)',
    stickerHeight: 'Tinggi (piksel)',
    stickerDuration: 'Tempoh',
    stickerTags: 'Tag',
    stickerDescription: 'Penerangan',
    statusTips: 'Sila pilih status',
    typeTips: 'Sila pilih jenis',
    categoryTips: 'Sila pilih kategori',
    editSticker: 'Edit pelekat',
    imgPreview: 'Pratonton imej',
    codeCheckResultErr: '❌ Kod ini sudah wujud, sila tukar',
    codeCheckResultOk: '✅ Kod boleh digunakan',
    inputCodeTips: 'Pilihan. Perbeza jenis pelekat mengikut akhiran kod (cth. ST2D). Disyorkan huruf besar, nombor dan garis bawah',
    categoryIcon: 'Ikon kategori',
    categoryName: 'Nama kategori',
    categoryCode: 'Kod kategori',
    categoryIconPlaceholder: 'Sila masukkan URL ikon',
    addCategory: 'Tambah kategori',
    editCategory: 'Edit kategori',
    groupNewAdd: 'Tambah kumpulan baru',
    groupEdit: 'Edit kumpulan',
    groupName: 'Nama kumpulan',
    groupCode: 'Kod kumpulan',
    groupIcon: 'Ikon kumpulan',
    hasSticker: 'Bilangan pelekat',
    groupCodePlaceholder: 'Sila masukkan kod kumpulan (huruf besar Inggeris)',
    groupNamePlaceholder: 'Sila masukkan nama kumpulan',
    groupDescriptionPHR: 'Sila masukkan penerangan kumpulan',
    controllerSticker: 'Kawal',
    addFailed: 'Tambah gagal',
    addSuccess: 'Tambah berjaya',
    confirmDeleteSticker: 'Adakah anda pasti ingin memadam pelekat ini?',
    deleteFailed: 'Padam gagal',
    deleteSuccess: 'Padam berjaya',
    fileDurationDesc: 'Khusus video/GIF, pilihan',
    fileDurationTips: 'Hanya diperlukan untuk pelekat video/GIF',
    fileSizeDesc: 'Diisi secara automatik selepas muat naik',
    fileSizeExample: 'cth: 51200',
    heightExample: 'cth: 200',
    widthExample: 'cth: 200',
    selectAtLeastOne: 'Sila pilih sekurang-kurangnya satu pelekat',
    selectSticker: 'Pilih Pelekat',
    stickerCodeDesc: 'Pengecam unik global, format STICKER_XXX disyorkan',
    stickerCodeTips: 'Sila masukkan kod pelekat (unik)',
    stickerImageSize: 'Saiz disyorkan: 200x200 piksel, menyokong format PNG, JPG',
    stickerSlected: 'Pelekat Dipilih',
    thumbnail: 'Lakaran Kecil',
    uploadStickerImage: 'Sila muat naik imej pelekat',
    inputStickerName: 'Sila masukkan nama pelekat',
    inputStickerCode: 'Sila masukkan kod pelekat',
    codeFormatTips: 'Disarankan menggunakan format STICKER_XXX',
    codeExists: 'Kod pelekat ini telah wujud, sila tukar',
    codeValidateFailed: 'Pengesahan gagal',
    codeValidateError: 'Gagal mengesahkan kod, sila cuba lagi',
    codeFormatError: 'Format kod salah, disarankan menggunakan format STICKER_XXX',
    codeCheckFailedRetry: 'Pengesahan gagal, sila cuba lagi',
    tagsPlaceholder: 'Asingkan berbilang tag dengan koma, contoh: gembira, emoji, senyum',
    tagsDesc: 'Digunakan untuk carian dan pengelasan',
    descPlaceholder: 'Sila masukkan penerangan pelekat',
    uploadImage: 'Muat Naik Imej',
    uploadThumbnail: 'Muat Naik Thumbnail',
    reuseStickerImage: 'Guna semula imej stiker',
    reuseStickerImageTip: 'Imbak kecil akan terus menggunakan imej stiker, muat naik berasingan tidak diperlukan',
    thumbnailOptional: 'Pilihan, sistem boleh jana secara automatik',
    thumbnailUploadSuccess: 'Thumbnail berjaya dimuat naik',
    selectCategoryAttr: 'Sila pilih kategori',
    completeFormInfo: 'Sila lengkapkan maklumat wajib dalam borang',
    sortOrderPlaceholder: 'Semakin kecil nombor, semakin atas',
    categoryCodePlaceholder: 'Sila masukkan kod kategori (huruf besar Inggeris)',
    categoryCodeDesc: 'Pengecam unik, disarankan huruf besar Inggeris, contoh: HOT, CUTE',
    inputCategoryName: 'Sila masukkan nama kategori',
    inputCategoryCode: 'Sila masukkan kod kategori',
    categoryCodePatternMsg: 'Sila masukkan huruf besar Inggeris, boleh mengandungi garis bawah',
    categoryCodeExists: 'Kod kategori ini telah wujud, sila tukar',
    uploadCategoryIcon: 'Sila muat naik ikon kategori',
    sortOrderMustNumber: 'Nombor susunan mesti nombor',
    categoryDescPlaceholder: 'Sila masukkan penerangan kategori',
    confirmDeleteCategory: 'Sahkan padam kategori ini?',
    exportDeveloping: 'Fungsi eksport sedang dibangunkan...',
    confirmDeleteGroup: 'Adakah anda pasti ingin memadam kumpulan ini?',
    selectGroupToDelete: 'Sila pilih kumpulan untuk dipadam',
    inputGroupName: 'Sila masukkan nama kumpulan',
    groupNameTooLong: 'Nama kumpulan tidak boleh melebihi 50 aksara',
    inputGroupCode: 'Sila masukkan kod kumpulan',
    groupCodeFormatMsg: 'Kod kumpulan hanya boleh mengandungi huruf besar Inggeris, nombor dan garis bawah',
    groupCodeTooLong: 'Kod kumpulan tidak boleh melebihi 50 aksara',
    groupCodeInvalidOrExists: 'Format kod kumpulan salah atau telah wujud, sila semak',
    uploadGroupIcon: 'Sila muat naik ikon kumpulan',
    sortOrderInvalid: 'Sila masukkan nombor susunan yang sah (nombor >= 0)',
    selectStatusEnableDisable: 'Sila pilih status (Aktif/Nyahaktif)',
    codeCheckErrorTips: '⚠️ Pengesahan kod gagal, sila cuba lagi nanti',
    editFailed: 'Gagal mengedit',
    operationFailedRetry: 'Operasi gagal, sila cuba lagi',
    apiException: 'Ralat sistem',
    selectStickerType: 'Sila pilih jenis pelekat'
  },
  filter: {
    filterName: 'Nama Filter',
    addFilter: '+ Tambah Filter',
    addFilterTitle: 'Tambah Filter',
    editFilterTitle: 'Sunting Filter',
    filterPreview: 'Pratonton Filter',
    filterOriginalImage: 'Imej Asal Filter',
    filterResourceFile: 'Fail Sumber Filter',
    belongCompany: 'Kedai',
    allMerchants: 'Semua Kedai',
    type: 'Jenis',
    builtIn: 'Binaan Dalam',
    nonBuiltIn: 'Bukan Binaan Dalam',
    appliedMachines: 'Mesin Digunakan',
    defaultSort: 'Susunan',
    serialNo: 'No.',
    batchCopy: 'Salin Pukal',
    copy: 'Salin',
    tip: 'Petua',
    deletePrompt: 'Memadam filter ini akan menyebabkan mesin tidak dapat menggunakannya. Adakah anda pasti mahu memadam?',
    editFilterSuccess: 'Filter berjaya disunting',
    loadCompanyFailed: 'Gagal memuatkan senarai kedai',
    copyFilterSuccess: 'Filter berjaya disalin',
    copyFilterFailed: 'Gagal menyalin filter',
    batchCopySuccess: 'Filter berjaya disalin pukal',
    batchCopyFailed: 'Gagal menyalin pukal filter',
    selectFilterFirst: 'Sila pilih filter untuk disalin terlebih dahulu',
    copyToMerchantTitle: 'Salin Filter ke Kedai',
    batchCopyTitle: 'Salin Filter Pukal ke Kedai',
    originalFilterName: 'Nama Filter Asal',
    newFilterName: 'Nama Filter Baru',
    inputNewFilterName: 'Sila masukkan nama filter baru',
    targetMerchant: 'Kedai Sasaran',
    selectCompany: 'Sila pilih kedai',
    selectedFilters: 'Filter Dipilih',
    nameSuffix: 'Akhiran Nama Seragam',
    inputNameSuffix: 'Sila masukkan akhiran nama seragam',
    nameSuffixTip: 'Nama filter baru = nama filter asal + akhiran ini',
    inputFilterName: 'Sila masukkan nama filter',
    inputName: 'Sila masukkan nama',
    selectTypeMsg: 'Sila pilih jenis',
    inputDefaultSort: 'Sila masukkan susunan',
    colorMatrix: 'Matriks Warna',
    whitening: 'Memutihkan',
    smoothing: 'Melicinkan Kulit',
    bigEye: 'Mata Besar',
    thinFace: 'Muka Kurus',
    smallFace: 'Muka Kecil',
    forehead: 'Dahi',
    cheekbone: 'Tulang Pipi',
    nose: 'Hidung',
    mouth: 'Mulut',
    chin: 'Dagu',
    intensity: 'Keamatan Filter',
    sampleFullColor: 'Sampel Warna Penuh:',
    colorModeExample: 'Contoh mod foto warna',
    pngFilterExample: 'Contoh asal filter PNG',
    anyFormatMax10M: 'Sebarang format, maks. 10 MB',
    colorModeNormal: 'Mod Warna - Biasa:',
    colorModePressed: 'Mod Warna - Tekan:',
    reuseAllSampleColor: 'Guna semula Sampel Warna Penuh untuk semua',
    addUploadImage: 'Tambah & muat naik imej',
    uploadFile: 'Muat Naik Fail',
    reupload: 'Muat Naik Semula',
    submit: 'Hantar',
    btnNormalRequired: 'Imej Mod Warna - Biasa tidak boleh kosong!',
    imageUrlRequired: 'Imej sampel warna penuh tidak boleh kosong!',
    filterPngRequired: 'Imej asal filter tidak boleh kosong!',
    btnSelectedRequired: 'Imej Mod Warna - Tekan tidak boleh kosong!',
    exceed10M: 'Melebihi had 10 MB, muat naik tidak dibenarkan~',
    uploadFailed: 'Muat naik gagal'
  },
  goods: {
    productName: 'Nama produk',
    newProductName: 'Nama produk baru',
    productCode: 'Kod produk',
    preview: 'Pratonton',
    width: 'Lebar',
    height: 'Tinggi',
    imageCount: 'Bilangan foto',
    frameTop: 'Bingkai atas',
    frameBottom: 'Bingkai bawah',
    frameLeft: 'Bingkai kiri',
    frameRight: 'Bingkai kanan',
    frameCount: 'Bilangan bingkai',
    printMode: 'Mod cetakan',
    orientation: 'Orientasi',
    price: 'Harga',
    companyPrice: 'Penetapan harga',
    increasePrice: 'Cetak tambahan',
    defaultIncreasePrice: 'Harga cetak tambahan',
    companyIncreasePrice: 'Penetapan harga cetak tambahan',
    type: 'Jenis',
    deviceCount: 'Bilangan peranti',
    operation: 'Operasi',
    confirmDelete: 'Selepas dipadam, mesin tidak akan dapat memilih produk ini. Anda pasti mahu memadam?',
    view: 'Lihat',
    edit: 'Edit',
    delete: 'Padam',
    search: 'Cari',
    addProduct: '+ Tambah produk',
    pleaseInputContent: 'Sila masukkan kandungan carian',
    sequenceNumber: 'No.',
    printingMode: 'Mod cetakan',
    oneCopyInDuplicate: 'Satu salinan',
    inDuplicate: 'Salinan',
    vertical: 'Menegak',
    horizontal: 'Melintang',
    riceConfirmation: 'Sila masukkan harga yang betul! Hanya boleh lebih besar atau sama dengan 0.01!',
    cannotEditBuiltIn: 'Produk terbina dalam tidak boleh diedit. Hanya supperAdmin boleh mengedit',
    cannotDeleteBuiltIn: 'Produk terbina dalam tidak boleh dipadam. Hanya supperAdmin boleh memadam',
    copy: 'Salin',
    copyProduct: 'Salin Produk',
    originalProductName: 'Nama Produk Asal',
    inputProductName: 'Sila masukkan nama produk baru',
    selectCompany: 'Sila pilih kedai',
    copySuccess: 'Produk berjaya disalin',
    frameManage: 'Urus Bingkai',
    orderNum: 'Susunan',
    belongCategory: 'Kategori',
    belongCompany: 'Peniaga',
    subCategory: 'Subkategori',
    groupName: 'Nama Kumpulan'
  },
  order: {
    orderManagement: 'Urus pesanan',
    orderList: 'Senarai pesanan',
    all: 'Semua',
    paid: 'Dibayar',
    completed: 'Selesai',
    unpaid: 'Belum bayar',
    refunded: 'Bayaran balik',
    timeout: 'Tamat masa',
    canceled: 'Dibatalkan',
    paying: 'Sedang bayar',
    unclose: 'Belum tutup',
    closed: 'Ditutup',
    toBeReversed: 'Perlu diterbalikkan',
    reversed: 'Diterbalikkan',
    evaluated: 'Dinilai',
    exception: 'Pengecualian',
    unknown: 'Tidak diketahui',
    payFail: 'Bayaran gagal',
    notRefund: 'T/A',
    applyRefund: 'Mohon bayaran balik',
    refundInProgress: 'Sedang bayar balik',
    agreeRefund: 'Setuju bayaran balik',
    refuseRefund: 'Tolak bayaran balik',
    refundedStatus: 'Bayaran balik selesai',
    refundFail: 'Bayaran balik gagal',
    cancelRefund: 'Batal bayaran balik',
    photo: 'Foto',
    print: 'Cetak',
    remotePrint: 'Cetak Jarak Jauh',
    viewRemotePhotos: 'Lihat foto',
    remotePrintPhotos: 'Foto Cetak Jarak Jauh',
    uploadPhotos: 'Foto dimuat naik',
    uploadPrint: 'Muat naik & Cetak',
    noPhotos: 'Tiada foto',
    orderNumber: 'Nombor pesanan',
    merchant: 'Kedai',
    deviceNumber: 'Nombor peranti',
    payMode: 'Cara bayar',
    orderType: 'Jenis pesanan',
    paymentStatus: 'Status bayaran',
    totalPrice: 'Jumlah harga',
    createTime: 'Masa cipta',
    payTime: 'Masa bayaran',
    quantity: 'Kuantiti',
    unitPrice: 'Harga seunit',
    discountAmount: 'Jumlah diskaun',
    refundStatus: 'Status bayaran balik',
    refundReason: 'Catatan pesanan',
    operation: 'Operasi',
    export: 'Eksport',
    orderCount: 'Bilangan pesanan',
    searchPlaceholder: 'Sila masukkan kandungan carian',
    agree: 'Setuju bayaran balik',
    refuse: 'Tolak bayaran balik',
    refund: 'Bayaran balik',
    viewPhoto: 'Lihat foto',
    gifImage: 'GIF animasi',
    confirmAgreeRefund: 'Anda pasti mahu meluluskan permohonan bayaran balik untuk pesanan ini?',
    agreeRefundContent: 'Selepas anda klik OK, pesanan ini akan menerima bayaran balik.',
    agreeRefundSuccess: 'Lulus bayaran balik pesanan berjaya',
    confirmRefuseRefund: 'Anda pasti mahu menolak permohonan bayaran balik untuk pesanan ini?',
    refuseRefundContent: 'Selepas anda klik OK, pesanan ini akan ditolak bayaran balik.',
    refuseRefundSuccess: 'Tolak bayaran balik pesanan berjaya',
    deviceName: 'Nama peranti',
    viewPhotos: 'Butiran Foto',
    photoDetail: 'Butiran Foto',
    compositePhotos: 'Foto Gabungan',
    originalPhotos: 'Foto Asal',
    noCompositePhotos: 'Tiada foto gabungan',
    noOriginalPhotos: 'Tiada foto asal',
    frameId: 'ID Bingkai',
    copyOrderCode: 'Salin kod pesanan',
    allMerchants: 'Semua Peniaga',
    allDevices: 'Semua Peranti',
    allPayModes: 'Semua Kaedah Bayaran',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Koin',
    payFree: 'Percuma',
    payCoupon: 'Kod Tukai',
    payDai: 'Token',
    payCoin: 'Syiling',
    payCash: 'Tunai',
    payCard: 'Kad',
    copySuccess: 'Berjaya disalin',
    copyFail: 'Gagal menyalin'
  },
  coupon: {
    all: 'Semua',
    notActivated: 'Belum Diaktifkan',
    activated: 'Diaktifkan',
    used: 'Digunakan',
    cancelled: 'Dibatalkan',
    searchPlaceholder: 'Sila masukkan kod kupon/nama kedai/nama peranti',
    export: 'Eksport',
    generateCoupon: 'Jana Kupon',
    qrCode: 'Kod QR',
    noQrCode: 'Tiada',
    clickToPreview: 'Klik untuk pratonton',
    couponQrCode: 'Kod QR Kupon',
    clickToDownload: 'Klik imej untuk muat turun',
    confirmCouponInfo: 'Sila sahkan maklumat kupon',
    merchantName: 'Nama Kedai',
    selectMerchant: 'Sila pilih kedai',
    deviceObject: 'Peranti',
    selectDeviceFirst: 'Sila pilih peranti dahulu',
    couponQuantity: 'Kuantiti Kupon',
    inputCouponQuantity: 'Sila masukkan kuantiti kupon',
    activateCoupon: 'Aktifkan Kupon',
    yes: 'Ya',
    no: 'Tidak',
    activate: 'Aktifkan',
    cancel: 'Batal',
    couponId: 'ID Kupon',
    merchant: 'Kedai',
    deviceName: 'Nama Peranti',
    couponCode: 'Kod Kupon',
    status: 'Status',
    createTime: 'Masa Cipta',
    operation: 'Operasi',
    activateSuccess: 'Berjaya diaktifkan!',
    activateFailed: 'Pengaktifan gagal!',
    cancelSuccess: 'Berjaya dibatalkan!',
    cancelFailed: 'Pembatalan gagal!',
    generateSuccess: 'Berjaya dijana!',
    generateFailed: 'Penjanaan gagal!',
    generating: 'Sedang menjana kupon, sila tunggu...',
    maxCouponLimit: 'Tidak boleh menjana lebih 500 kupon sekaligus!',
    generateTip: 'Maksimum 500 kupon boleh dijana dalam satu masa. Sila jana secara berperingkat jika memerlukan lebih. Setiap mesin boleh menjana sehingga 2000 kupon sebulan.',
    selectMerchantFirst: 'Sila pilih kedai dahulu!',
    downloadSuccess: 'Muat turun berjaya!',
    superCoupon: 'Kupon Super',
    setSuperCoupon: 'Tetapkan sebagai Kupon Super',
    setSuperCouponConfirm: 'Adakah anda pasti mahu menetapkan kupon ini sebagai kupon super? Kupon super sedia ada pada peranti ini akan diturunkan ke kupon biasa secara automatik.',
    setSuperCouponSuccess: 'Kupon super berjaya ditetapkan!',
    setSuperCouponFailed: 'Gagal menetapkan kupon super!',
    delete: 'Padam',
    batchDelete: 'Padam Pukal',
    deleteConfirm: 'Adakah anda pasti mahu memadamkan kupon ini? Tidak dapat dipulihkan selepas dipadam!',
    batchDeleteConfirm: 'Adakah anda pasti mahu memadamkan {count} kupon yang dipilih? Tidak dapat dipulihkan selepas dipadam!',
    deleteSuccess: 'Berjaya dipadam!',
    deleteFailed: 'Gagal memadam!',
    selectDeleteFirst: 'Sila pilih kupon yang mahu dipadam dahulu!'
  },
  dashboard: {
    date: 'Tarikh',
    flow: 'Aliran pelanggan',
    companyCount: 'Bilangan kedai baru',
    deviceCount: 'Bilangan peranti baru',
    photoCount: 'Bilangan pesanan foto',
    printCount: 'Bilangan pesanan cetak',
    amount: 'Jumlah pendapatan platform',
    justSumAmount: 'Bahagian platform',
    companySumAmount: 'Bahagian kedai',
    lineCount: 'Bilangan peranti dalam talian',
    companyName: 'Nama kedai',
    deviceCode: 'Kod peranti',
    activeCode: 'Kod peranti',
    deviceName: 'Nama peranti',
    photo: 'Bilangan pesanan foto',
    print: 'Bilangan pesanan cetak',
    totalPrice: 'Jumlah pendapatan platform',
    timeCycle: 'Masa',
    defaultTimeFilter: 'Penapis masa lalai (bulan)',
    month: 'Bulan',
    week: 'Minggu',
    day: 'Hari',
    search: 'Cari',
    export: 'Eksport',
    refund: 'Bayaran balik',
    confirmRefund: 'Anda pasti mahu memohon bayaran balik untuk pesanan ini?',
    refundContent: 'Selepas anda klik OK, pesanan ini akan memulakan permohonan bayaran balik.',
    refundSuccess: 'Permohonan bayaran balik pesanan berjaya',
    confirmAgreeRefund: 'Anda pasti mahu meluluskan permohonan bayaran balik untuk pesanan ini?',
    agreeRefundContent: 'Selepas anda klik OK, pesanan ini akan menerima bayaran balik.',
    agreeRefundSuccess: 'Lulus bayaran balik pesanan berjaya',
    confirmRefuseRefund: 'Anda pasti mahu menolak permohonan bayaran balik untuk pesanan ini?',
    refuseRefundContent: 'Selepas anda klik OK, pesanan ini akan ditolak bayaran balik.',
    refuseRefundSuccess: 'Tolak bayaran balik pesanan berjaya',
    timeRangeRequired: 'Julat masa tidak boleh kosong'
  },
  uiGroup: {
    uiGroupManage: 'Urus kumpulan UI',
    newUIGroup: 'Kumpulan UI baru',
    searchUIName: 'Cari nama kumpulan UI...',
    resourceType: 'Jenis sumber',
    adminDefine: 'Takrif pentadbir',
    merchantDefine: 'Takrif kedai',
    uiName: 'Nama UI',
    subPageCount: 'Bilangan halamanย่อย',
    downloadPackage: 'Muat turun pakej',
    onlyOneInCategoryCannotDelete: 'Hanya tinggal satu kumpulan UI dalam kategori ini (bahasa + produk), tidak boleh dipadam',
    remark: 'Catatan',
    createTime: 'Masa cipta',
    pageManage: 'Urus halaman',
    copy: 'Salin',
    copyPrompt: 'Anda pasti mahu menyalin kumpulan UI ini?',
    copySuccess: 'Salin berjaya',
    copyFail: 'Salin gagal',
    copyUIGroup: 'Salin Kumpulan UI',
    originalUIName: 'Nama Kumpulan UI Asal',
    newUIName: 'Nama Kumpulan UI Baru',
    inputNewUIName: 'Sila masukkan nama kumpulan UI baru',
    selectCompany: 'Sila pilih syarikat',
    companyName: 'Nama Syarikat',
    addUIGroup: 'Kumpulan UI baru',
    deletePrompt: 'Anda pasti mahu memadam kumpulan UI ini?',
    deleteSuccess: 'Padam berjaya',
    editUIGroup: 'Edit kumpulan UI',
    editSuccess: 'Edit berjaya',
    addSuccess: 'Tambah kumpulan UI berjaya',
    addFail: 'Tambah kumpulan UI gagal',
    newPage: 'Halaman baru',
    editPage: 'Edit halaman',
    addPage: 'Tambah halaman',
    pageName: 'Nama halaman',
    pageKey: 'Kunci halaman',
    pageOrder: 'Susunan halaman',
    elementCount: 'Bilangan elemen',
    elementManage: 'Urus elemen',
    pleaseInputPageName: 'Sila masukkan nama halaman',
    pleaseInputPageKey: 'Sila masukkan kunci halaman',
    pleaseInputPageOrder: 'Sila masukkan susunan halaman',
    deletePagePrompt: 'Anda pasti mahu memadam halaman ini? Tidak boleh dipulihkan selepas dipadam!',
    addPageSuccess: 'Tambah halaman berjaya',
    addPageFail: 'Tambah halaman gagal',
    editPageSuccess: 'Edit halaman berjaya',
    editPageFail: 'Edit halaman gagal',
    deletePageSuccess: 'Padam halaman berjaya',
    deletePageFail: 'Padam halaman gagal',
    pageKeyExists: 'Kunci halaman sudah wujud, sila tukar',
    productType: 'Jenis produk',
    elementName: 'Nama elemen',
    elementType: 'Jenis elemen',
    allElement: 'Semua elemen',
    editElement: 'Edit elemen',
    addElement: 'Tambah elemen',
    elementValue: 'Nilai elemen',
    elementValueMsg: 'Sila masukkan nilai elemen',
    elementKey: 'Kunci elemen',
    elementKeyMsg: 'Sila masukkan kunci elemen',
    elementKeyPlaceholder: 'Kunci elemen tidak boleh berulang dalam halaman yang sama, disyorkan gunakan huruf dan garis bawah',
    elementNameMsg: 'Sila masukkan nama elemen',
    elementTypeMsg: 'Sila pilih jenis elemen',
    elementKeyError: 'Kunci elemen sudah wujud pada halaman semasa, sila tukar',
    elemnetDeleteTips: 'Anda pasti mahu memadam elemen ini?',
    batchEditElement: 'Edit elemen berkumpulan',
    horizontalLayout: 'Susun atur mendatar',
    verticalLayout: 'Susun atur menegak',
    loadingElementList: 'Sedang memuat senarai elemen...',
    allResourceType: 'Semua jenis sumber',
    pleaseInputUIName: 'Sila masukkan nama kumpulan UI',
    pleaseSelectResourceType: 'Sila pilih jenis sumber',
    previewImage: 'Imej Pratonton',
    reupload: 'Muat Naik Semula',
    uploadPreviewImage: 'Muat Naik Pratonton',
    languageType: 'Bahasa',
    selectLanguageType: 'Sila pilih bahasa',
    pageSize: 'Saiz Halaman',
    pixelWH: 'Piksel (L×T)',
    belongCompany: 'Peniaga',
    cancelDefaultConfirm: 'Adakah anda pasti mahu membatalkan status lalai kumpulan UI ini?',
    setDefaultConfirm: 'Adakah anda pasti mahu menetapkan kumpulan UI ini sebagai lalai?',
    operateSuccess: 'Operasi berjaya!',
    operateFail: 'Operasi gagal',
    onlyJpgPng: 'Hanya imej JPG dan PNG boleh dimuat naik!',
    exceed4M: 'Saiz imej tidak boleh melebihi 4MB!',
    uploadSuccess: 'Muat naik berjaya',
    uploadSuccessNoUrl: 'Muat naik berjaya tetapi tidak dapat memperoleh URL imej',
    inputImageUrlPlaceholder: 'Atau masukkan URL imej secara terus (http/https)',
    useImageUrl: 'Guna URL ini',
    invalidImageUrl: 'Sila masukkan URL imej yang sah (bermula dengan http:// atau https://)',
    imageUrlApplied: 'URL imej dipakai',
    pasteTip: 'Petua: Selepas menyalin imej atau mengambil tangkapan skrin, tekan Ctrl+V/Cmd+V untuk tampal dan muat naik',
    pasteUploadSuccess: 'Imej tampal berjaya dimuat naik',
    langZhCN: 'Cina Ringkas',
    langEn: 'Inggeris',
    langFr: 'Perancis',
    langKo: 'Korea',
    langZhTW: 'Cina Tradisional',
    langVi: 'Vietnam',
    langAr: 'Arab',
    langBih: 'Bosnia',
    langTh: 'Thai',
    langDe: 'Jerman',
    langEs: 'Sepanyol'
  },
  deviceSetup: {
    title: 'Tetapan Peranti',
    basicInfo: 'Maklumat Asas',
    machineModelSN: 'Kod Mesin [SN]',
    inputMachineSN: 'Sila masukkan kod SN',
    machineName: 'Nama Mesin',
    inputMachineName: 'Sila masukkan nama mesin',
    machineCode: 'Kod Peranti',
    inputMachineCode: 'Sila masukkan kod peranti',
    machineAddress: 'Alamat Mesin',
    inputMachineAddress: 'Sila masukkan alamat',
    activationCode: 'Kod Pengaktifan',
    h5Url: 'URL Halaman H5',
    parseUrl: 'Hurai URL',
    urlEditorTitle: 'Pengurusan Parameter URL H5',
    urlBase: 'URL asas',
    urlParams: 'Parameter URL',
    paramName: 'Nama parameter',
    paramValue: 'Nilai parameter',
    addParam: 'Tambah parameter',
    noParams: 'Tiada parameter. Klik "Tambah parameter"',
    done: 'Selesai',
    pasteTip: 'Petua: Selepas menyalin imej atau mengambil tangkapan skrin, tekan Ctrl+V untuk tampal dan muat naik',
    pasteUploadSuccess: 'Imej tampal berjaya dimuat naik',
    filterByCompany: 'Tapis mengikut peniaga',
    customerServicePhone: 'Nombor Telefon Sokongan',
    photoAccessType: 'Kaedah Akses Foto',
    selectPhotoAccessType: 'Sila pilih jenis',
    paymentMode: 'Mod Pembayaran',
    selectPaymentMode: 'Sila pilih jenis',
    onlinePayment: 'Pembayaran Dalam Talian',
    offlineCoin: 'Syiling Offline',
    scanQRCode: 'Imbas Kod QR',
    addFriend: 'Tambah Rakan',
    machineSettings: 'Tetapan Mesin',
    uiGroupSelection: 'Pilihan Kumpulan UI',
    selectUiGroup: 'Sila pilih kumpulan UI',
    uiSelection: 'Pilihan UI',
    searchUiName: 'Cari nama UI',
    viewAll: 'Semua',
    viewSelected: 'Dipilih Sahaja',
    builtIn: ' terbina dalam',
    notBuiltIn: 'Tidak Terbina Dalam',
    productSelection: 'Pilihan Produk',
    searchProductName: 'Cari nama produk',
    selectAll: 'Pilih Semua',
    frameSelection: 'Pilihan Bingkai',
    selectProductFirst: 'Sila pilih produk dahulu',
    searchFrameName: 'Cari nama bingkai',
    noProductSelected: 'Sila pilih sekurang-kurangnya satu produk dahulu',
    noFrameData: 'Tiada data bingkai untuk produk ini',
    filterSelection: 'Pilihan Penapis',
    searchFilterName: 'Cari nama penapis',
    stickerGroup: 'Kumpulan Pelekat',
    searchGroupName: 'Cari nama kumpulan',
    noStickerGroupData: 'Tiada data kumpulan pelekat',
    stickersCount: '{count} pelekat',
    parameterSettings: 'Tetapan Parameter',
    photoTime: 'Masa Foto',
    seconds: 'saat',
    inputPhotoTime: 'Sila masukkan masa foto',
    intervalTime: 'Masa Selang',
    inputIntervalTime: 'Sila masukkan masa selang',
    paperCount: 'Bilangan Kertas',
    sheets: 'helai',
    inputPaperCount: 'Sila masukkan bilangan kertas',
    paperCountRequired: 'Bilangan kertas diperlukan',
    cancel: 'Batal',
    save: 'Simpan',
    selectAtLeastOneProduct: 'Sila pilih sekurang-kurangnya satu produk',
    selectAtLeastOneFilter: 'Sila pilih sekurang-kurangnya satu penapis',
    paperCountMinLimit: 'Bilangan kertas tidak boleh kurang daripada 50',
    serverConnectionError: 'Ralat sambungan pelayan, sila cuba sebentar lagi!',
    deviceThumbnail: 'Lakaran Kecil Peranti',
    modify: 'Ubah',
    upload: 'Muat Naik',
    remoteDesktopInfo: 'Maklumat Desktop Jarak Jauh',
    remoteDesktopPlaceholder: 'Sila masukkan maklumat desktop jarak jauh (kod jarak jauh)',
    format: 'Format',
    belongCategory: 'Kategori',
    selectBelongCategory: 'Sila pilih kategori',
    onlyJpgPng: 'Hanya imej JPG dan PNG boleh dimuat naik~',
    exceed4M: 'Melebihi had 4M, muat naik tidak dibenarkan~',
    thumbnailUploadFailed: 'Gagal memuat naik lakaran kecil',
    jsonFormatErrorFormat: 'Format JSON tidak sah, tidak dapat diformat, sila semak dan cuba lagi',
    jsonFormatError: 'Format JSON tidak sah, sila semak dan cuba lagi',
    showName: 'Nama Paparan Peranti (Imbas kod QR untuk muat turun tajuk halaman foto elektronik)',
    showNamePlaceholder: 'Dipaparkan sebagai tajuk di halaman muat turun foto elektronik'
  },
  personal: {
    oldPassword: 'Kata laluan lama',
    inputOldPassword: 'Sila masukkan kata laluan lama',
    strength: 'Kekuatan: ',
    passwordTip: 'Sila masukkan sekurang-kurangnya 6 aksara. Jangan guna kata laluan yang mudah ditebak.',
    newPassword: 'Kata laluan baharu',
    passwordPlaceholder: 'Sekurang-kurangnya 6 aksara, bezakan huruf besar/kecil',
    confirmPassword: 'Sahkan semula',
    confirmPasswordPlaceholder: 'Sahkan kata laluan',
    levelLow: 'Lemah',
    levelMedium: 'Sederhana',
    levelStrong: 'Kuat',
    minSixChars: 'Sila masukkan kata laluan sekurang-kurangnya 6 aksara',
    strengthNotEnough: 'Kekuatan kata laluan tidak mencukupi',
    inputPassword: 'Sila masukkan kata laluan',
    passwordNotMatch: 'Dua kata laluan tidak sepadan',
    oldPasswordIncorrect: 'Kata laluan lama tidak betul',
    editProfile: 'Sunting profil',
    updateAvatar: 'Tukar avatar',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar berjaya dikemas kini',
    email: 'E-mel',
    mobile: 'Telefon bimbit',
    dept: 'Jabatan',
    gender: 'Jantina',
    description: 'Penerangan',
    inputEmail: 'Sila masukkan e-mel',
    inputMobile: 'Sila masukkan nombor telefon bimbit',
    emailInvalid: 'Sila masukkan e-mel yang sah',
    emailMax: 'Panjang tidak boleh melebihi 50 aksara',
    mobileInvalid: 'Sila masukkan nombor telefon bimbit yang sah',
    selectGender: 'Sila pilih jantina',
    descMax: 'Panjang tidak boleh melebihi 100 aksara',
    submit: 'Hantar',
    selectAvatar: 'Pilih avatar',
    clickToSelect: 'Klik untuk memilih',
    updatingWarning: 'Sedang menukar avatar, jangan klik berulang kali',
    updateAvatarFailed: 'Gagal mengemas kini avatar',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Siri Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Maklumat pengguna',
    account: 'Akaun: ',
    role: 'Peranan: ',
    noRole: 'Tiada peranan',
    male: 'Lelaki',
    female: 'Perempuan',
    confidential: 'Sulit',
    department: 'Jabatan: ',
    noDepartment: 'Tiada jabatan',
    gender: 'Jantina: ',
    phone: 'Telefon: ',
    noPhone: 'Telefon belum diikat',
    email: 'E-mel: ',
    noEmail: 'E-mel belum diikat',
    status: 'Status: ',
    locked: 'Dikunci',
    valid: 'Aktif',
    createTime: 'Dicipta: ',
    lastLogin: 'Log masuk terakhir: ',
    description: 'Penerangan: '
  },
  remotePrint: {
    loading: 'Memuatkan...',
    expired: 'Rekod Telah Luput',
    expiredDesc: 'Rekod muat naik ini telah tamat tempoh. Sila kembali ke terminal dan cuba lagi.',
    completed: 'Selesai',
    completedDesc: 'Foto telah berjaya dihantar. Sila tunggu di terminal untuk cetakan.',
    submitted: 'Berjaya Dihantar',
    submittedDesc: 'Foto telah dihantar ke terminal. Sila lengkapkan langkah seterusnya pada mesin.',
    orderInfo: 'Maklumat Pesanan',
    recordCode: 'No. Rekod',
    orderCode: 'No. Pesanan',
    product: 'Produk',
    price: 'Harga',
    expireTime: 'Luput Pada',
    photos: 'Foto',
    addPhoto: 'Tambah Foto',
    tipFormat: 'Hanya menyokong format JPG/PNG',
    tipSize: 'Setiap foto tidak melebihi 3MB',
    tipExpire: 'Rekod sah selama 5 minit, sila muat naik dengan segera',
    submit: 'Muat Naik & Cetak',
    submitting: 'Menghantar...',
    noRecordCode: 'Tiada kod rekod. Sila imbas kod QR.',
    loadFailed: 'Gagal memuat. Sila cuba lagi.',
    invalidFormat: 'Hanya menyokong JPG/PNG',
    photoLimit: 'Hanya boleh memuat naik sehingga {count} foto',
    fileTooLarge: 'Saiz fail tidak boleh melebihi 10MB',
    uploadFailed: 'Muat naik gagal. Sila cuba lagi.',
    noPhotoUploaded: 'Sila muat naik sekurang-kurangnya satu foto',
    submitFailed: 'Penghantaran gagal. Sila cuba lagi.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ms-MY.js